import { NAV_DATA } from 'constants/navConstants';
import featureFlags from '../../../../util/featureFlags';

const {
  SECONDARY: { PAPER, GUEST_LIST, WEBSITE },
} = NAV_DATA; // TODO: edit GUEST_LIST after gmPhase1 to prod

const gmPhase1 = featureFlags.get('guestManagerP1');

class SecondaryNavDataV2 {
  constructor(userContext = {}) {
    this.userContext = userContext;
  }

  // Invites - Pre/post auth
  getInvitesItems() {
    const saveTheDate = {
      path: '/wedding-planning/save-the-date/shop',
      title: 'Save The Dates',
      id: PAPER.SAVE_THE_DATE,
      parent: 'Invites + Paper',
    };
    const changeTheDate = {
      path: '/wedding-planning/change-the-date/shop',
      title: 'Change The Dates',
      newTag: true,
      id: PAPER.CHANGE_THE_DATE,
      parent: 'Invites + Paper',
    };
    const invitations = {
      path: '/wedding-planning/invitations/shop',
      title: 'Invitations',
      id: PAPER.INVITATION,
      parent: 'Invites + Paper',
    };
    const enclosureCards = {
      path: '/wedding-planning/enclosures/shop',
      title: 'Enclosure Cards',
      id: PAPER.DETAILS,
      parent: 'Invites + Paper',
    };
    const menus = {
      path: '/wedding-planning/menus/shop',
      title: 'Menus',
      id: PAPER.MENU,
      parent: 'Invites + Paper',
    };
    const programs = {
      path: '/wedding-planning/programs/shop',
      title: 'Programs',
      id: PAPER.PROGRAM,
      parent: 'Invites + Paper',
    };
    const thankYouCards = {
      path: '/wedding-planning/thank-you-cards/shop',
      title: 'Thank You Cards',
      id: PAPER.THANK_YOU,
      parent: 'Invites + Paper',
    };
    const holidayCards = {
      path: '/wedding-planning/holiday-cards/shop',
      title: 'Holiday Cards',
      id: PAPER.HOLIDAY,
      parent: 'Invites + Paper',
    };

    const items = [
      saveTheDate,
      changeTheDate,
      invitations,
      enclosureCards,
      menus,
      programs,
      thankYouCards,
      holidayCards,
    ];

    if (this.userContext.has_invitation_account) {
      items.unshift({
        title: 'Your Orders + Drafts',
        path: '/wedding-planning/projects',
        id: PAPER.PROJECTS,
        parent: 'Invites + Paper',
      });
    }

    return items;
  }

  // Guest List - Post auth
  // could be static
  getGuestListItems() {
    const guestDirectory = {
      path: '/wedding/manage/guests/all',
      title: 'Your Guests',
      id: GUEST_LIST.ALL_GUESTS,
      parent: 'Guest List',
    };
    const events = {
      path: '/wedding/manage/events',
      title: 'Your Events',
      id: GUEST_LIST.EVENTS,
      parent: 'Guest List',
    };
    const buildGuestLists = {
      path: '/wedding/manage/guests/build',
      title: 'Build Guest Lists',
      id: GUEST_LIST.BUILD,
      parent: 'Guest List',
    };
    const addressEnvelopes = {
      path: '/wedding/manage/guests/envelopes',
      title: 'Address Envelopes',
      id: GUEST_LIST.ENVELOPES,
      parent: 'Guest List',
    };
    const trackRSVP = {
      path: '/wedding/manage/guests/rsvps/overview',
      title: 'Track RSVPs',
      id: GUEST_LIST.TRACK_RSVPS,
      parent: 'Guest List',
    };
    // const requestRsvpAccess = {
    //   path: '/wedding/manage/guests/rsvp-notifications',
    //   // receivesNotifications: true,
    //   title: 'View RSVP Requests',
    //   id: GUEST_LIST.RSVP_REQUESTS,
    //   parent: 'Guest List',
    // };
    const seatingChart = {
      title: gmPhase1 ? 'Your Seating Chart' : 'Seating Chart',
      path: '/wedding/manage/seating',
      id: GUEST_LIST.SEATING,
      parent: 'Guest List',
    };
    const hotelBlocks = {
      title: 'Hotel Blocks',
      path: 'https://zola.hotelplanner.com/Group-Rate/?kw=guestnav',
      parent: 'Guest List',
    };

    const guestListWithSubitems = {
      path: '/wedding/manage/guests/all',
      title: 'Your Guest List',
      id: GUEST_LIST.ALL_GUESTS,
      parent: 'Guest List',
      showCaret: true,
      children: [
        {
          path: '/wedding/manage/guests/all',
          title: 'Manage Guest List',
        },
        {
          path: '/wedding/manage/guests/build',
          title: 'Invite Guests to Events',
        },
        {
          path: '/wedding/manage/guests/envelopes',
          title: 'Address Envelopes',
        },
        {
          path: '/wedding/manage/guests/rsvps/overview',
          title: 'Track RSVPs',
        },
      ],
    };

    return gmPhase1
      ? [guestListWithSubitems, events, seatingChart, hotelBlocks]
      : [guestDirectory, events, buildGuestLists, addressEnvelopes, trackRSVP, seatingChart];
  }

  // Website - Post auth
  // Could be static
  getWebsiteItems() {
    const manageWebsite = {
      id: WEBSITE.MANAGE,
      path: '/wedding/manage/website/manage',
      title: 'Your Website',
      parent: 'Website',
    };

    const editWebsite = {
      id: WEBSITE.EDIT,
      path: '/wedding/manage/website/pages/home',
      title: 'Edit Pages',
      parent: 'Website',
    };

    const viewDesigns = {
      id: WEBSITE.DESIGNS,
      path: '/wedding/manage/website/designs',
      title: 'View Designs',
      parent: 'Website',
    };

    return [manageWebsite, editWebsite, viewDesigns];
  }
}

export default SecondaryNavDataV2;



// WEBPACK FOOTER //
// ./src/components/common/header/SecondaryNavV2/SecondaryNavDataV2.js